import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FlexModule, ExtendedModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-info-message-dialog',
  templateUrl: './info-message-dialog.component.html',
  styleUrls: ['./info-message-dialog.component.scss'],
  standalone: true,
  imports: 
  [
    CommonModule,
    FlexModule, 
    ExtendedModule, 

    MatButtonModule, 
    MatIconModule,
    MatDialogModule,
  ]
})
export class InfoMessageDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<InfoMessageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: InfoMessageDialogComponent,
  ) { }
}
